const BLOCK = 'LStudio__app_timeline';

/*
    🔥 LÍNEA DE TIEMPO

    items: [{ id, title, description, date, icon, tone, meta, isActive }]

    Sirve para historial de un registro, feed de actividad y estado de
    un envío. Son la misma forma con distinto contenido.

    ⚠️ LA FECHA VIENE FORMATEADA DESDE AFUERA

    Este componente NO formatea fechas. Ya tenés dateTransform.helper y
    el _timeAgo del header: meter una tercera manera de mostrar fechas
    haría que la misma fecha se vea de tres formas según la pantalla.

    ⚠️ VA COMO <ol>, NO COMO DIVS

    Una línea de tiempo es una secuencia ordenada. Un lector de
    pantalla anuncia "lista de 6 elementos" y el usuario sabe cuánto
    falta; con divs escucha seis bloques sueltos sin relación.
*/

export const TimelineItem = ({
    title,
    description = null,
    date = null,
    icon = null,
    tone = 'neutral',
    meta = null,
    isActive = false,
    children = null,
}) => (

    <li className={`${BLOCK}__item`} data-tone={tone} data-active={isActive}>

        <span className={`${BLOCK}__marker`} aria-hidden="true">
            {icon ?? <span className={`${BLOCK}__dot`} />}
        </span>

        <div className={`${BLOCK}__content`}>

            <div className={`${BLOCK}__head`}>

                <p className={`${BLOCK}__title`}>{title}</p>

                {date && <time className={`${BLOCK}__date`}>{date}</time>}

            </div>

            {description && <p className={`${BLOCK}__text`}>{description}</p>}

            {children && <div className={`${BLOCK}__slot`}>{children}</div>}

            {meta && <div className={`${BLOCK}__meta`}>{meta}</div>}

        </div>

    </li>
);

export const Timeline = ({
    items = null,
    variant = 'line',            // line | compact | cards
    align = 'left',              // left | alternate
    children = null,
}) => (

    <ol className={BLOCK} data-variant={variant} data-align={align}>
        {
            items
                ? items.map((item, index) => (
                    <TimelineItem key={item.id ?? index} {...item} />
                ))
                : children
        }
    </ol>
);
